<template>
    <div class="page-container ssaEntrancePage">
        <a :href="links.ironsrc" target="_self" class="logo" v-once>
            <IconBase width="150" height="36" :iconColor="consts.COLORS_V2.DARK_500"
                      icon-name="companyLogoIcon">
            </IconBase>
        </a>
        <div class="center-content">
            <div class="top-bar" v-if="topBar" v-once></div>
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import links from 'services/metaData/links';

export default {
    name: 'EntrancePageLayout',
    components: { IconBase },
    props: {
        topBar: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            consts,
            links
        };
    }
};
</script>

<style lang="scss" scoped>
@import "~styles/styleGuide.V2";

.page-container {
    background-color: $light-100;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    a.logo {
        top: 18px;
        left: 33px;
        position: absolute;
    }
}

.center-content {
    width: 400px;
    border-radius: 8px;
    box-shadow: 0 4px 24px 0 rgba(0, 0, 0, 0.15);
    background-color: $white;
}

.top-bar {
    background-color: $primary-500;
    height: 4px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

.content {
    height: 100%;
    min-height: 200px;
}
</style>
